import { v4 as uuid } from 'uuid';
import type { ToastProps, ToastPropsBase } from '../../hooks/Toast/useToasts';
import { globalToastActions, globalToastsDispatch } from './GlobalToastsStore';

// Overloaded class for type safety
export class GlobalToastManager<TToastProps extends ToastPropsBase = ToastPropsBase> {
  constructor(private toastType: 'ui' | 'appInbox') {}

  /**
   * Adds a toast, with a registerable type given to the class above
   */
  public addToast(toast: TToastProps, onRemove?: (id: string) => void): string {
    if (!toast.id) {
      toast.id = uuid();
    }

    if (this.toastType === 'ui') {
      // TODO: Typing could likely still be improved here
      const toastValue = toast as unknown as ToastProps & { id: string };
      globalToastsDispatch(
        globalToastActions.addToastWithTimeout(
          {
            type: 'ui',
            value: {
              dismissable: true,
              timeout: toastValue.variant === 'NEGATIVE' ? 5000 : 3000,
              ...toastValue,
            },
          },
          onRemove
        )
      );
    } else {
      globalToastsDispatch(
        globalToastActions.addToastWithTimeout(
          {
            type: 'appInbox',
            value: {
              dismissable: true,
              // fallback timeout - primary timeouts provided in AppNotificationsMonitor
              timeout: 15_000,
              ...toast,
            },
          },
          onRemove
        )
      );
    }
    return toast.id!;
  }

  public removeToast(id: string): void {
    globalToastsDispatch(globalToastActions.remove({ type: this.toastType, id }));
  }

  public clearToasts(): void {
    globalToastsDispatch(globalToastActions.clear({ type: this.toastType }));
  }
}
